import * as Yup from 'yup';
import { FormDialogBox } from '../../../../components/CustomDialogBox';
import CustomFilterForm from './CustomFilterForm';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .max(25, 'Name must be at most 25 characters')
    .required('Enter a name for Account View'),
});

function CustomFilterDialog(props) {
  const {
    open,
    handleClose,
    isNew,
    isEdit,
    initialValues,
    handleSave,
    handleEdit,
    handleDelete,
  } = props;

  const onSubmitHandler = (values) => {
    if (isEdit) {
      handleEdit(values);
    } else {
      handleSave(values);
    }
    handleClose();
  };

  const onDeleteHandler = () => {
    handleDelete();
    handleClose();
  };

  return (
    <FormDialogBox
      title="Save As Account View"
      open={open}
      handleClose={handleClose}
      onSubmit={onSubmitHandler}
      initialValues={initialValues}
      validationSchema={validationSchema}
      formContent={<CustomFilterForm isNew={isNew} />}
      formAction={
        isEdit
          ? [
            {
              label: 'Delete',
              size: 'small',
              variant: 'outlined',
              onClick: onDeleteHandler,
            },
            {
              label: 'Update',
              size: 'small',
              type: 'submit',
            },
          ]
          : [
            {
              label: 'Save',
              size: 'small',
              type: 'submit',
            },
          ]
      }
    />
  );
}

export default CustomFilterDialog;
